/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.logic_compare = {
  OPERATORS: [
    ['=', 'EQ'],
    ['≠', 'NEQ'],
    ['<', 'LT'],
    ['≤', 'LTE'],
    ['>', 'GT'],
    ['≥', 'GTE'],
  ],
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_COMPARE);
    this.appendValueInput('B')
      .appendField(new Blockly.FieldDropdown(this.OPERATORS), 'OP')
      .appendField(Blockly.Msg.LANG_COMPARE_TO);
    this.setInputsInline(true);
    this.setTooltip(() => Blockly.Blocks.logic_compare.TOOLTIPS[this.getFieldValue('OP')]);
  },
};

Blockly.Blocks.logic_compare.TOOLTIPS = {
  EQ: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_EQ,
  NEQ: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_NEQ,
  LT: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_LT,
  LTE: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_LTE,
  GT: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_GT,
  GTE: Blockly.Msg.LANG_LOGIC_COMPARE_TOOLTIP_GTE,
};

Blockly.Blocks.logic_operation = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A').setCheck('Boolean');
    this.appendValueInput('B')
      .setCheck('Boolean')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_LOGIC_OPERATION_AND || 'AND', 'AND'],
        [Blockly.Msg.LANG_LOGIC_OPERATION_OR || 'OR', 'OR'],
      ]), 'OP');
    this.setInputsInline(true);
    this.setTooltip(() => Blockly.Blocks.logic_operation.TOOLTIPS[this.getFieldValue('OP')]);
  },
};

Blockly.Blocks.logic_operation.TOOLTIPS = {
  AND: Blockly.Msg.LANG_LOGIC_OPERATION_TOOLTIP_AND,
  OR: Blockly.Msg.LANG_LOGIC_OPERATION_TOOLTIP_OR,
};

Blockly.Blocks.logic_negate = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('BOOL')
      .setCheck('Boolean')
      .appendField(Blockly.Msg.LANG_LOGIC_NEGATE_INPUT_NOT);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_NEGATE_TOOLTIP);
  },
};

// logic_compare_* no tienen input B: cada uno arma su umbral fijo en el generador Arduino.
Blockly.Blocks.logic_compare_ultrasonic = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_COMPARE_ULTRASONIC);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_CLOSE, '0'],
        [Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_FAR, '1'],
      ]), 'DIST');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

Blockly.Blocks.logic_compare_humidity = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_COMPARE_HUMIDITY);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COMPARE_HUMIDITY_wet, '0'],
        [Blockly.Msg.LANG_COMPARE_HUMIDITY_dry, '1'],
      ]), 'HUM');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

Blockly.Blocks.logic_compare_obstacle = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_COMPARE_OBSTACLE);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

Blockly.Blocks.logic_compare_noise = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_COMPARE_NOISE);
    this.appendDummyInput('')
      // Opciones hardcodeadas en español a propósito, como el legacy.
      .appendField(new Blockly.FieldDropdown([
        ['ruido', '0'],
        ['silencio', '1'],
      ]), 'NOISE');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

// Se redefine el built-in solo para forzar la forma redonda de prod: sin esto
// zelos lo dibuja hexagonal (por el check 'Boolean').
Blockly.Blocks.logic_boolean = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_LOGIC_BOOLEAN_TRUE, 'TRUE'],
        [Blockly.Msg.LANG_LOGIC_BOOLEAN_FALSE, 'FALSE'],
      ]), 'BOOL');
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};
